module.exports = __webpack_public_path__ + "static/img/qibaoge.208ab770.jpg";